import React from "react"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { FormTextField } from "@/nzds/forms/form-text-field/form-text-field"
import { urlSchema } from "@/schemas"

import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded"
import IconButton from "@mui/material/IconButton"
import InputAdornment from "@mui/material/InputAdornment"

interface CredentialWebsiteFieldValues {
  website: string
}

export const CredentialWebsiteField: React.FC = () => {
  const { t } = useTranslation("common")
  const form = useFormContext<CredentialWebsiteFieldValues>()
  const watchedWebsite = form.watch("website")
  const parsedWebsite = urlSchema.safeParse(watchedWebsite)
  const canOpenWebsite = parsedWebsite.success

  const handleOpenWebsite = () => {
    if (!parsedWebsite.success) {
      return
    }

    globalThis.open(parsedWebsite.data, "_blank", "noopener,noreferrer")
  }

  return (
    <FormTextField<CredentialWebsiteFieldValues>
      label={t("admin.credentialsUi.websiteLabel")}
      name="website"
      required
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={t("admin.credentialsUi.openWebsiteAriaLabel")}
                disabled={!canOpenWebsite}
                edge="end"
                onClick={handleOpenWebsite}
              >
                <OpenInNewRoundedIcon />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      variant="stacked"
    />
  )
}
